// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"4b2256b2","321":"9194449e","386":"1261564e","453":"28fc22fd","484":"6a8efcc7","589":"50081ad3","977":"96c68f37"}[chunkId] + ".chunk.js";
};